import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ModalService } from '@common/services/modal.service';
import { DataService, PaymentRecord, PaymentType, PaymentState, PartnerRecord, DebtRecord } from '@core/services/data.service';
import { NumberInputComponent } from '@common/UI/number-input/number-input.component';

@Component({
  templateUrl: './customer-debt-editor.component.html',
  styleUrls: ['./customer-debt-editor.component.scss']
})
export class CustomerDebtEditorComponent implements OnInit {

  constructor(private modal: ModalService, private ds: DataService) { }

  @Input()
  public partner: PartnerRecord;

  ngOnInit(): void {
    this.debt.ID = this.partner.ID;
  }

  @Output()
  public create = new EventEmitter<DebtRecord>();

  public debt: DebtRecord = {
    ID: 0,
    Name: '',
    Total: 0,
    Symbol: 'VND',
    Icon: 'đ',
    Type: 'adjustment',
    Stamp: new Date().getTime(),
    Reason: ''    
  };

  public get time(): Date {
    return new Date(this.debt.Stamp);
  }

  public set time(date: Date) {
    this.debt.Stamp = date.getTime();
  }

  public close() {
    this.modal.of(this).hide();
  }

  public update(editor: NumberInputComponent) {
    if (isNaN(editor.value)) editor.value = 0;

    this.debt.Total = -editor.value;
  }

  public save() {
    if (this.debt.Total != 0) {
      this.ds.debts('create', this.debt).subscribe(debt => {
        if (debt && debt.length == 1) {
          this.create.emit(debt[0]);
          this.close();
        }
      });
    }
  }

}
